/* eslint-disable @typescript-eslint/no-explicit-any */
import { H5 } from '@ansvar-sakerhet/ui/src/typography/H5';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Select } from '../../components/Select';
import { useCompanyEvents } from '../../traits/api/frameCompany/useCompanyEvents';
import { useFindAllUsersFrameCompany } from '../../traits/api/frameCompany/useFindAllUsersFrameCompany';
import { useUser } from '../../traits/hooks/useUser';
import { S } from './FrameCompanyEvents.styled';

export const FrameCompanyEvents: React.FC = () => {
  const { user } = useUser();
  const { data: frameCompanyUsers } = useFindAllUsersFrameCompany();
  const [responsible, setResponsible] = useState<string | null>();
  const { mutateAsync } = useCompanyEvents();
  const [frameCompanies, setFrameCompanies] = useState<any[]>([]);
  const navigate = useNavigate();
  useEffect(() => {
    const search = async () => {
      if (responsible) {
        const a = await mutateAsync(responsible ?? '');
        setFrameCompanies(a.data as unknown as any[]);
      }
    };
    search();
  }, [responsible, mutateAsync]);

  useEffect(() => {
    if (frameCompanyUsers && frameCompanyUsers.customerUsers) {
      const currentUser = frameCompanyUsers.customerUsers.find(
        (usr: any) => usr.externalId === user.sub
      ) as any;
      if (currentUser && !responsible) {
        setResponsible(currentUser.customerUserId);
      }
    }
  }, [frameCompanyUsers, user.sub]);

  return (
    <div>
      <div style={{ height: '100%' }}>
        <H5>Filtrera efter ansvarig person</H5>
        <Select
          style={{ height: '100%' }}
          label=""
          value={responsible === null ? undefined : responsible}
          onChange={(e) => setResponsible(e.target.value)}
        >
          <option key={'all'} value={'all'}>
            Alla
          </option>
          <option key={'no_responsible'} value={'no_responsible'}>
            Ingen ansvarig
          </option>

          {frameCompanyUsers?.customerUsers
            .sort((a: any, b: any) => {
              return a.firstName.localeCompare(b.firstName);
            })
            .map((user: any) => (
              <option key={user.customerUserId} value={user.customerUserId}>
                {user.firstName} {user.lastName}
              </option>
            ))}
        </Select>
        <S.Margin $top="xl" />
        <S.FrameCompanies>
          <H5>Ändringar sedan senaste kreditkontrollen</H5>
          {frameCompanies.map((company: any) => (
            <div key={company.frameCompanyId} style={{ width: '100%' }}>
              <S.B1 style={{ fontWeight: 400 }}>
                {company.name} (Senast kontrollerad:{' '}
                {new Date(
                  company.CreditControl[0].createdAt
                ).toLocaleDateString()}{' '}
                med rating: {company.CreditControl[0].rating})
              </S.B1>
              <ul>
                {company.changes.map((change: any, index: number) => (
                  <li key={index}>
                    <S.Margin $top="s" />
                    <S.B2>
                      {change.description}{' '}
                      {new Date(change.changeDate).toLocaleDateString()}
                    </S.B2>
                  </li>
                ))}
              </ul>
              <S.Button
                style={{ height: 40, width: 160 }}
                onClick={() => {
                  navigate(`/ramavtals-foretag/${company.frameCompanyId}`);
                }}
              >
                Visa företag
              </S.Button>
              <S.Margin $top="xl" />
            </div>
          ))}
        </S.FrameCompanies>
      </div>
    </div>
  );
};
